module.exports = __webpack_public_path__ + "img/3_16.0d67ecbe.png";